import React from 'react';
import { Paper } from '@material-ui/core';
import 'ag-grid-enterprise';
import PropTypes from 'prop-types';
import { AgGridReact } from 'ag-grid-react';
import '../../styles/ThresholdNotifications.scss';

const debug = process.env.NODE_ENV !== 'production';
const PAGINATION_SIZE = 100;

class InventoryGrid extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      rowData: [],
      popupParent: document.querySelector('body'),
      defaultColDefs: {
        sortable: true,
        filter: true,
        resizable: true,
      },
      columnDefInventory: [
        {
          headerName: 'Id',
          field: 'id',
          pinned: 'left',
          hide: true,
        },
        {
          headerName: 'Pricer',
          field: 'pricer',
          pinned: 'left',
          filter: 'agTextColumnFilter',
          editable: true,
          resizable: true,
          cellEditorSelector: () => {
            return {
              component: 'agRichSelectCellEditor',
              params: { values: props.tags.filter(t => t.tags.pricer !== null).map(t => t.tags.pricer) },
            };
          },
          onCellValueChanged: this.onCellValueChanged,
        },
        {
          headerName: 'Venue',
          field: 'venue_name',
          pinned: 'left',
          filter: 'agTextColumnFilter',
          sortable: true,
          resizable: true,
        },
        {
          headerName: 'Date',
          field: 'event_date',
          filter: 'agDateColumnFilter',
          sortable: true,
          resizable: true,
          autoHeight: true,
          sort: 'asc',
        },
        {
          headerName: 'COTA',
          field: 'cota',
          filter: 'agNumberColumnFilter',
          sortable: true,
          resizable: true,
          autoHeight: true,
        },
        {
          headerName: 'Held',
          field: 'sb_total_num_held',
          filter: 'agNumberColumnFilter',
          sortable: true,
          resizable: true,
          autoHeight: true,
          maxWidth: 100,
          cellStyle: { textAlign: 'right' },
        },
        {
          headerName: 'Sold',
          field: 'sb_total_num_sold',
          filter: 'agNumberColumnFilter',
          sortable: true,
          resizable: true,
          maxWidth: 100,
          cellStyle: { textAlign: 'right' },
        },
        {
          headerName: '1D Pace',
          field: 'one_day_sb_pace',
          filter: 'agNumberColumnFilter',
          sortable: true,
          resizable: true,
          maxWidth: 100,
          cellStyle: { textAlign: 'right' },
        },
        {
          headerName: '3D Pace',
          field: 'three_day_sb_pace',
          filter: 'agNumberColumnFilter',
          sortable: true,
          resizable: true,
          maxWidth: 100,
          cellStyle: { textAlign: 'right' },
        },
        {
          headerName: '7D Pace',
          field: 'seven_day_sb_pace',
          filter: 'agNumberColumnFilter',
          sortable: true,
          resizable: true,
          maxWidth: 100,
          cellStyle: { textAlign: 'right' },
        },
        {
          headerName: 'Links',
          field: 'event_links',
          cellRendererFramework: params => <div style={{ display: 'flex' }}>{params.value}</div>,
          widt: 1000,
          sortable: false,
          resizable: true,
          suppressMenu: true,
        },
      ],
    };
  }

  serverSideDataSource = (events, fetchEventsFunction) => ({
    getRows(params) {
      const { endRow, sortModel } = params.request;
      const page = endRow / PAGINATION_SIZE;
      const getPricer = (eventsList, eventId) => {
        const event = eventsList.find(ev => ev.id === eventId);
        return event.tags ? event.tags.pricer : '';
      };
      fetchEventsFunction(events, page - 1, sortModel).then(res => {
        const rowData = res.rows.map(e => ({ ...e, pricer: getPricer(events, e.id) }));
        if (rowData.length) {
          const lastRow = () => {
            if (res.totalEvents <= PAGINATION_SIZE) return res.totalEvents;
            if (page <= Math.round(res.totalEvents / PAGINATION_SIZE) - 2) return -1;
            return res.totalEvents;
          };
          params.successCallback(rowData, lastRow());
        } else {
          params.successCallback([{ columnNameField: 'No results found' }], 1);
        }
      });
    },
  });

  onGridReady = params => {
    const { events, fetchEventsFunction } = this.props;
    const dataSource = this.serverSideDataSource(events, fetchEventsFunction);
    this.gridApi = params.api;
    this.gridApi.setServerSideDatasource(dataSource);
    this.gridApi.sizeColumnsToFit();
  };

  onSelectionChangedHandler = () => {
    this.gridApi.getSelectedNodes();
  };

  onCellValueChanged = params => {
    const { assignUserToEventFunction } = this.props;
    assignUserToEventFunction(params.data.id, params.newValue);
  };

  getRowNodeId = data => data.id.toString();

  render() {
    const { theme } = this.props;
    const { columnDefInventory, rowData, defaultColDefs, popupParent } = this.state;

    return (
      <Paper
        square
        className={theme.palette.type === 'dark' ? 'ag-theme-balham-dark' : 'ag-theme-balham'}
        style={{
          boxSizing: 'border-box',
          width: '100%',
        }}
      >
        <AgGridReact
          onSelectionChanged={this.onSelectionChangedHandler}
          columnDefs={columnDefInventory}
          rowData={rowData}
          onGridReady={this.onGridReady}
          defaultColDefs={defaultColDefs}
          getRowNodeId={this.getRowNodeId}
          pagination
          rowSelection="multiple"
          floatingFilter
          animateRows
          debug={debug}
          domLayout="autoHeight"
          rowModelType="serverSide"
          cacheBlockSize={100}
          popupParent={popupParent}
        />
      </Paper>
    );
  }
}

InventoryGrid.propTypes = {
  theme: PropTypes.object.isRequired,
  fetchEventsFunction: PropTypes.func.isRequired,
  events: PropTypes.array.isRequired,
  tags: PropTypes.array.isRequired,
  assignUserToEventFunction: PropTypes.func.isRequired,
};

export default InventoryGrid;
